
import { Text } from "@chakra-ui/react"
import { IDistrict } from "types/district"

export const getColumns = (T: any): any => {
  return [
    {
      // keyword - districts.table.columns.name
      key: "districts.table.columns.name",
      label: T("districts.table.columns.name"),
      render: (data: IDistrict) => {
        return <Text>{`districts.table.${data?.name}`}</Text>
      },
      hasClick: true,
    },
  ]

}